import { render, staticRenderFns } from "./PageExploreMiniGames.vue?vue&type=template&id=3e50dacc&scoped=true&"
import script from "./PageExploreMiniGames.vue?vue&type=script&lang=js&"
export * from "./PageExploreMiniGames.vue?vue&type=script&lang=js&"
import style0 from "./PageExploreMiniGames.vue?vue&type=style&index=0&id=3e50dacc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e50dacc",
  null
  
)

export default component.exports